import { getClient } from "@stadium/services/apollo-client";
import { getApolloAuthLink } from "@stadium/services/apollo-client";

import {
  ORDER_SERVICE_API_URL,
  PRODUCT_SERVICE_GRAPHQL_API_BASE_URL,
  REWARDS_SERVICE_GRAPHQL_API_BASE_URL,
  SEARCH_SERVICE_GRAPHQL_API_BASE_URL,
  USER_SERVICE_GRAPHQL_API_BASE_URL,
} from "@constants/env-variables";

const DEFAULT_CLIENT_PARAMS = {
  defaultUri: "products",
  endpoints: {
    products: PRODUCT_SERVICE_GRAPHQL_API_BASE_URL,
    rewards: REWARDS_SERVICE_GRAPHQL_API_BASE_URL,
    search: SEARCH_SERVICE_GRAPHQL_API_BASE_URL,
    users: USER_SERVICE_GRAPHQL_API_BASE_URL,
  },
  restEndpoint: ORDER_SERVICE_API_URL,
};
export const getAuthLink = (token) => getApolloAuthLink({ token, ...DEFAULT_CLIENT_PARAMS });

export const client = getClient(DEFAULT_CLIENT_PARAMS);
